import React from 'react';

export default function LoginSignupFormInput({ label, type, id, placeHolder, value, onChange, checked }) {
  return (
    <div className="login_signup_input_container">
      <label htmlFor={id}>{label}</label>
      <input type={type} className="login_signup_input" id={id} placeholder={placeHolder} name={id} value={value} onChange={onChange} checked={checked} />
    </div>
  )
}
